import loadable from '@loadable/component';
import { useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../components/layout/Layout';
import { RoleEnum } from '../../models/Index';
import StateService from '../../services/stateService/StateService';
import '../../styles.scss';
import '../../styles/grid-styles.css';
import '../../styles/resize-styles.css';
import GlobalHeader from '../globalHeader/GlobalHeader';
import Navigation from '../navigation/Navigation';
import OnlineHelp from '../online-help/OnlineHelp';
import ReleaseNotes from '../online-help/release-notes/ReleaseNotes';
import Reseller from '../online-help/Reseller';

export const CustomerSettings = loadable(() => import('../customer-settings/CustomerSettings'));
export const LinkoutStage = loadable(() => import('../../components/linkout-stage/LinkoutStage'));
export const StageGrouping = loadable(() => import('../stage-grouping/StageGrouping'));
export const ProtectedRoute = loadable(() => import('./protected-route/ProtectedRoute'));

function Routing() {
    const navigate = useNavigate();
    const [currentRoles, setCurrentRoles] = useState([] as RoleEnum[]);
    const [rolesPresent, setRolesPresent] = useState(false);
    const theme = useTheme();

    useEffect(() => {
        const currentRoles$ = StateService.currentRoles$.subscribe((currentRoles) => {
            setCurrentRoles(currentRoles);
        });

        const selectedRoute$ = StateService.selectedRoute$.subscribe((route) => {
            navigate(route);
        });

        return () => {
            currentRoles$.unsubscribe();
            selectedRoute$.unsubscribe();
        };
    }, []);

    useEffect(() => {
        setRolesPresent(currentRoles.length > 0 && currentRoles[0].length > 0 ? true : false);
    }, [currentRoles]);

    return (
        <>
            {rolesPresent && (
                <Routes>
                    <Route
                        path="/"
                        element={
                            <>
                                <Layout />
                            </>
                        }
                    />
                    <Route
                        path="/help"
                        element={
                            <div>
                                <Reseller />
                            </div>
                        }
                    />
                    <Route
                        path="/customer-settings"
                        element={
                            <ProtectedRoute context={'customerSettings'} roles={currentRoles}>
                                <GlobalHeader />
                                <div
                                    className="wrapper"
                                    style={{ display: 'flex', height: 'calc(100vh - 140px)', margin: `0 ${theme.spacing(4)} 0 0` }}
                                >
                                    <Navigation propWidth="240px" />
                                    <CustomerSettings />
                                </div>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dashboard-grouping"
                        element={
                            <ProtectedRoute context={'stageGrouping'} roles={currentRoles}>
                                <GlobalHeader />
                                <div
                                    className="wrapper"
                                    style={{ display: 'flex', height: 'calc(100vh - 140px)', margin: `0 ${theme.spacing(4)} 0 0` }}
                                >
                                    <Navigation propWidth="240px" />
                                    <StageGrouping />
                                </div>
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/customer/:customerId/stage/:stageId" element={<LinkoutStage />} />
                </Routes>
            )}
        </>
    );
}

export default Routing;
